/* eslint-disable filenames/match-exported */
import { isOperator } from '../../filterQueryFormat/operator/Operator';
import { useContext, useEffect, useState } from 'react';
import SegmentationFiltersInstanceContext from 'customer-data-filters-ui/state/SegmentationFiltersInstanceContext';
import { useStrategy } from '../../hooks/useStrategy';
import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import FilterOperatorDisplay from 'customer-data-filters-ui/components/operator/FilterOperatorDisplay';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasFieldOverrideV2 } from '../../permissions/gates';
import { Map as ImmutableMap } from 'immutable';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ViewerPropertyNameAndValueCondition = props => {
  const {
    condition
  } = props;
  const {
    currencyCode,
    data,
    getIsUngated,
    props: {
      translationPrefix
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getField,
    getFieldDefinitions,
    getValueResolver,
    getReferencedObjectType,
    getSpecialOptionsForReferenceType,
    getFilterFamilyObjectName,
    getOperatorsForType
  } = useStrategy();
  const {
    getFieldLabelString
  } = useTranslationHelpers(
  // @ts-expect-error need better OperatorInstance typing
  condition.referencedObjectTypeId);
  const [propertyName, setPropertyName] = useState('');
  useEffect(() => {
    const loadField = async () => {
      const field = condition.propertyValue && isOperator(condition.propertyValue) ? condition.propertyValue.field : await getField(condition.referencedObjectTypeId, condition.propertyName);
      setPropertyName(getFieldLabelString(field));
    };
    void loadField();
  }, [condition, getField, getFieldLabelString]);
  const fieldDefinitions = hasFieldOverrideV2(getIsUngated) ? ImmutableMap({}) : getFieldDefinitions(
  // @ts-expect-error ts-migrate(2554) FIXME
  condition.referencedObjectTypeId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "property-name",
        message: "customerDataFiltersUI.propertyValueChangedEvent.viewerPropertyName",
        options: {
          propertyName
        }
      })
    }), condition.propertyValue && /*#__PURE__*/_jsxs(View, {
      "data-test-id": "property-value",
      marginBlockStart: "200",
      as: "div",
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.propertyValueChangedEvent.newValue"
        })
      }), ' ', /*#__PURE__*/_jsx(FilterOperatorDisplay, {
        currencyCode: currencyCode,
        data: data,
        fieldDefinitions: fieldDefinitions,
        filterFamily: condition.referencedObjectTypeId,
        getFamilyValueResolver: getValueResolver.bind(null, condition.referencedObjectTypeId),
        getFilterFamilyObjectName: getFilterFamilyObjectName,
        getLabelString: getFieldLabelString,
        getReferencedObjectType: getReferencedObjectType.bind(null,
        // @ts-expect-error need better OperatorInstance typing
        condition.referencedObjectTypeId),
        getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
        getIsUngated: getIsUngated,
        isReadOnly: true,
        isXoEnabled: true,
        hideRestrictedAsset: true,
        operator: condition.propertyValue,
        translationPrefix: translationPrefix,
        getOperatorsForType: getOperatorsForType
      })]
    })]
  });
};
export default ViewerPropertyNameAndValueCondition;